import { icons } from "assets/AssetHelper";
import dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("complaints.customer_name"),
        name: data?.customer?.name,
      },
      {
        label: t("complaints.order_number"),
        name: "#" + data?.order_id,
      },
      {
        label: t("complaints.email"),
        name: data?.complaint_email,
      },
      {
        label: t("complaints.complain_reason"),
        name: data?.order_complaint_reasons
          ?.map((reason) => reason?.name)
          .join(", "),
      },
      {
        label: t("complaints.date_and_time"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("complaints.status"),
        name:
          data?.status === "open"
            ? t("complaints.not_resolved")
            : t("complaints.resolved"),
        color: data?.status === "open" ? "#D20000" : "#29B95F",
      },
      {
        label: t("complaints.feedback"),
        name: data?.feedback,
      },
    ],
  },
];
